module.exports = __webpack_public_path__ + "img/Image_9.0a220684.png";